import React from 'react';

import PropTypes from 'prop-types';

import { exerciseTypes } from 'z-js-commons';

import BarrageCorrection from './barrage';
import DragDropCorrection from './drag-drop';
import FillBlanksCorrection from './fill-blanks';
import FillChoiceCorrection from './fill-choice';
import FindErrorCorrection from './find-error';

import MultipleChoiceCorrection from './multiple-choice';
import OpenAnswerCorrection from './open-answer';
import SingleChoiceCorrection from './single-choice';
import TrueFalseCorrection from './true-false';
import CheckerCorrection from './checker';

const selectCorrectionComponent = (exercise) => {
    const exerciseType = exerciseTypes.getExerciseTypeFromName(exercise.typeLabel);

    switch (exerciseType) {
        case exerciseTypes.TRUE_FALSE:
            return TrueFalseCorrection;
        case exerciseTypes.FILL_CHOICE:
            return FillChoiceCorrection;
        case exerciseTypes.FILL_BLANKS:
            return FillBlanksCorrection;
        case exerciseTypes.MULTIPLE_CHOICE:
            const correctAnswers = exercise.options.filter((x) => x.correct);
            return correctAnswers.length === 1 ? SingleChoiceCorrection : MultipleChoiceCorrection;
        case exerciseTypes.DRAG_DROP:
            return DragDropCorrection;
        case exerciseTypes.SHOTS:
            return BarrageCorrection;
        case exerciseTypes.FIND_ERROR:
            return FindErrorCorrection;
        case exerciseTypes.OPEN_ANSWER:
            return OpenAnswerCorrection;
        case exerciseTypes.CHECKER:
            return CheckerCorrection;
        default:
            return null;
    }
};

const Correction = ({ answers, exercise, solution = false, correctionStatus }) => {
    const CorrectionComponent = selectCorrectionComponent(exercise);

    return (
        CorrectionComponent && (
            <CorrectionComponent answers={answers} exercise={exercise} solution={solution} correctionStatus={correctionStatus} />
        )
    );
};

Correction.propTypes = {
    answers: PropTypes.shape({
        exerciseId: PropTypes.number,
        answer: PropTypes.array,
    }),
    exercise: PropTypes.object,
    solution: PropTypes.bool,
    correctionStatus: PropTypes.object,
};

export default Correction;
